<template>
  <div class="item" @click="goDetail(item)" v-if="item">
    <div class="item-img">
      <img :src="item.cover_img" alt="" @error="imgError(item)">
      <div class="defaultRedBtnBox" v-if="item.award">
        <div class="defaultRed-btn">
          <div class="btn item-tips ellipsis">{{ item.award }}</div>
        </div>
      </div>
    </div>
    <div class="item-txt">
      <div class="item-title">
        <p v-text="item.name" :title="item.name"></p>
        <span class="label" v-if="item.type_tag_name">{{ item.type_tag_name | formatShowFirst }}</span>
        <span class="label" v-if="!item.type_tag_name && item.type_name">{{ item.type_name | formatShowFirst }}</span>
      </div>
      <div class="item-pub">
        <!-- <p class="elv" ><span>奖项级别：</span><em>{{item.award_level_name ||'暂无'}}</em></p>
        <p class="time" v-if="item.award_time"><span>时间：</span><em>{{item.award_time | GetYear}}</em></p> -->
        <p class="comp" v-if="item.performance_unit"><span>表演单位：</span><em :title="item.performance_unit">{{
          item.performance_unit | formatStandardSep }}</em></p>
        <p class="comp" v-if="!item.performance_unit && item.publish_unit"><span>出版单位：</span><em
            :title="item.publish_unit">{{ item.publish_unit | formatStandardSep }}</em></p>
      </div>
      <!-- <div class="item-info" > {{item.activity_name}}</div> -->
    </div>
  </div>
</template>

<script>
import { has } from 'lodash-es';


export default {
  name: 'awardItem',
  components: {

  },
  props: {
    item: Object,
    access: String,
    path: String
  },
  data() {
    return {
    };
  },
  methods: {
    goDetail(info) {
      const access = this.access || info.no_access || 0
      const hash = this.$utils.hashNum(access);
      if (this.path) {
        let link = this.$router.resolve({
          path: this.path + '/' + info.id + '/' + hash,
        });
        window.open(link.href, '_blank');
        return;
      }
      let path = this.$utils.matchProgramPath(info);
      try {
        if (this.$route.meta.detailPage) {
          this.$router.push({
            path: path + '/' + info.id + "/" + hash,
          });
          return;
        }
        let link = this.$router.resolve({
          path: path + '/' + info.id + "/" + hash,
        });
        window.open(link.href, '_blank');
      }
      catch (err) {
        this.$router.push({
          path: path + '/' + info.id + "/" + hash,
        });
      }
    }
  },
}
</script>
<style lang="scss" scoped>
.item {
  .item-img {
    box-sizing: border-box;
    padding: 1px;
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
}
</style>